var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GoogleButton } from "../GoogleButton";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { AuthTermsNotice } from "./AuthTermsNotice";
import { UserContext } from "./UserProvider";
var Login = function () {
    var _a;
    var _b = useContext(UserContext), setUser = _b.setUser, setUserLoading = _b.setLoading;
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var _d = __read(useState(null), 2), error = _d[0], setError = _d[1];
    var navigate = useNavigate();
    var location = useLocation();
    var from = ((_a = location.state) === null || _a === void 0 ? void 0 : _a.from) || "/";
    var login = useGoogleLogin({
        onSuccess: function (tokenResponse) {
            setLoading(true);
            axios
                .post("/dj-rest-auth/google/", {
                access_token: tokenResponse.access_token,
            })
                .then(function (response) {
                var user = response.data.user;
                setLoading(false);
                setUser(user);
                setUserLoading(false);
                navigate(from);
            })
                .catch(function () {
                setLoading(false);
                setError("Login failed. Please try again.");
            });
        },
    });
    var handleCloseSnackbar = function () {
        setError(null);
    };
    return (_jsx(Container, { component: "main", maxWidth: "xs", children: _jsxs(Box, { sx: {
                mt: { xs: 6, sm: 10 },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }, children: [loading ? (_jsx(CircularProgress, { role: "progressbar" })) : (_jsxs(React.Fragment, { children: [_jsx(SportsSoccerIcon, { sx: { fontSize: 48, color: "primary.main", mb: 2 } }), _jsx(Typography, { role: "heading", component: "h1", variant: "h4", sx: { fontWeight: 700, mb: 1 }, children: "Log in to Log.Soccer" }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 4, textAlign: "center" }, children: "Pick up where you left off." }), _jsx(GoogleButton, { onClick: function () { return login(); }, text: "Log in with Google" }), _jsx(AuthTermsNotice, {})] })), _jsx(ErrorSnackbar, { open: !!error, onClose: handleCloseSnackbar, message: error || "" })] }) }));
};
export default Login;
